import { useContext } from 'react'

import { ListingProfileContext } from '../../RentalPortalListingProfile.context'

export function useListingProfileContext() {
  return useContext(ListingProfileContext)
}
